export default function cardData (data) {
	return data
}